import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compone clases de Tailwind resolviendo los conflictos.
 *
 * `clsx` decide qué clases entran y `tailwind-merge` decide cuál gana cuando
 * dos hablan de lo mismo: en `cn('px-4', props.className)` con `px-6` fuera,
 * gana `px-6`. Sin esto —que es como estaba la interfaz, cosiendo cadenas con
 * plantillas— las dos clases acaban en el DOM y quien manda es el orden en que
 * Tailwind las emitió, que no es el que nadie escribió.
 *
 * `clsx`, `tailwind-merge` y `class-variance-authority` ya estaban en las
 * dependencias sin que nadie los importara.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
